export const NewClientsListHeader = () => {
  return <>NewClientsListHeader</>;
};
